import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import entityPath from './entityPath';

const USER_PATH_USER_FRAGMENT = gql(`
  fragment userPath_user on UserFields {
    id
    name
  }
`);

export default function userPath(
  user: DocumentType<typeof USER_PATH_USER_FRAGMENT>,
) {
  return `/users/${entityPath(user.name, user.id)}`;
}
